import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import Title from "../../components/Title/Title";
import '../../styles/Source-Link.css';

export default function Gestures() {

    return (
        <div>
            <NavBar/>
            <Title text={"Sobre os Gestos na Santa Missa"}/>

            <p className="info-text">
                <strong>Sinal da Cruz</strong><br/>
                É o sinal do cristão e profissão de fé no mistério da Santíssima Trindade.<br/>
                Esse sinal significa que colocamos todos os nossos atos debaixo da Santíssima Trindade.
            </p> 

            <p className="info-text">
                <strong>Sentado</strong><br/>
                É a Posição mais cômoda, que facilita bem a instrução da palavra de Deus,
                Para que a pessoa fique a vontade e possa meditar melhor.
            </p> 

            <p className="info-text">
                <strong>De pé</strong><br/>
                Atitude de grande seriedade, indica, portanto, prontidão, disposição para obedecer imediatamente.
                É próprio de quem ouve com especial atenção e respeito, tendo grande consideração pela pessoa que fala.
            </p> 


            <p className="info-text">
                <strong>De Joelhos</strong><br/>
                É norma ajoelhar-se diante à Eucaristia e na Consagração; essa atitude significa homenagens a um soberano.
                Representa a adoração à Deus e humildade na oração. 

            </p> 


            <p className="info-text">
                <strong>Genuflexão</strong><br/>
                É um gesto de adoração a Jesus na Eucaristia, desde que exista a presença da mesma.
            </p>

            
            <p className="info-text">
                <strong>Inclinação (Venia)</strong><br/>
                Inclinar-se diante de alguém é um gesto de profundo respeito, uma deferência(consideração) especial e também adoração.
            </p>

            <p className="info-text">
                <strong>Procissão</strong><br/>
                Na Missa, podem-se fazer várias procissões caso for conveniente: na entrada, no Evangelho, ofertório, comunhão.
                Elas simbolizam também a peregrinação de um povo em direção a casa do Pai.
            </p>
            
            <p className="info-text">
                <strong>Mãos Levantadas</strong><br/>
                Significam súplica e entrega do orante.
            </p>
            
            <p className="info-text">
                <strong>Mãos Juntas</strong><br/>
                Significam recolhimento, busca de Deus no seu interior, fé, súplica, confiança e entrega a Deus.
            </p>

            
            <p className="info-text">
                <strong>Prostação</strong><br/>
                Significa Morrer para o mundo e nascer para Deus. É o gesto de ajoelhar-se e encostar o rosto, cabeça no chão.
            </p>

            
            <p className="info-text">
                <strong>Silêncio</strong><br/>
                Possibilita melhor aprofundamento no mistério de Deus, o Senhor fala no silêncio do coração.
            </p> 

            <p className="info-text">
                <strong>Canto</strong><br/>
                Expressão de Fé, alegria, fraternidade, louvor do povo à Deus, reunido família na casa do Pai.
            </p>

            <Footer/>
        </div>
    )
}